import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import EarlyAccessModal from './EarlyAccessModal';

const AlertaioPromo: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-blue-600 rounded-lg shadow-xl p-8 text-white mb-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-start gap-6">
          <div className="hidden md:block">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
              <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-2xl font-bold mb-3">
              Never Overspend on AI APIs Again with Alertaio
            </h3>
            <p className="text-blue-100 mb-4 text-lg">
              Now that you know the costs, let Alertaio monitor your actual AI API usage in real-time and alert you before you exceed your budget.
            </p>
            
            <div className="grid md:grid-cols-2 gap-4 mb-6">
              <div className="flex items-start gap-3">
                <div className="text-green-300 text-xl mt-1">✓</div>
                <div>
                  <h4 className="font-semibold mb-1">Real-Time Cost Monitoring</h4>
                  <p className="text-sm text-blue-100">Track your OpenAI API spending in real-time (more providers coming soon!)</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-green-300 text-xl mt-1">✓</div>
                <div>
                  <h4 className="font-semibold mb-1">Smart Budget Alerts</h4>
                  <p className="text-sm text-blue-100">Get notified via email, Slack, or webhook when approaching spending limits</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-green-300 text-xl mt-1">✓</div>
                <div>
                  <h4 className="font-semibold mb-1">Usage Analytics</h4>
                  <p className="text-sm text-blue-100">Detailed insights into which models and endpoints cost you the most</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="text-green-300 text-xl mt-1">✓</div>
                <div>
                  <h4 className="font-semibold mb-1">Cost Optimization Tips</h4>
                  <p className="text-sm text-blue-100">AI-powered recommendations to reduce your API costs</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-white text-indigo-600 hover:bg-blue-50 font-semibold px-6 py-3 rounded-lg transition-colors inline-flex items-center gap-2"
              >
                Start Monitoring for Free
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
              
              <Link 
                to="/#features"
                className="border-2 border-white text-white hover:bg-white/10 font-semibold px-6 py-3 rounded-lg transition-colors"
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-white/20">
          <p className="text-sm text-blue-100 text-center">
            Trusted by developers at startups and enterprises • Free plan available • No credit card required
          </p>
        </div>
      </div>
      
      <EarlyAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default AlertaioPromo;
